import service from '@/utils/request'
// 查询供应商附件信息
export function supplierAttachList(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierAttach/supplierAttachList',
        data: param
    })
}
// 查询供应商附件信息 不分页
export function supplierAttachListAll() {
    return service.request({
        method: 'POST',
        url: '/app/supplierAttach/list',
    })
}
// 新增供应商附件信息
export function addSupplierAttach(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierAttach/add',
        data: param
    })
}
// 修改供应商附件信息
export function editSupplierAttach(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierAttach/edit',
        data: param
    })
}

// 批量删除供应商附件信息
export function batchDelSupplierAttach(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierAttach/batchDel',
        data: param
    })
}



// 删除供应商附件信息
export function delSupplierAttach(param) {
    return service.request({
        method: 'POST',
        url: '/app/supplierAttach/del',
        data: param
    })
}
